// baseColor and spotColor off each 1.8.9 EntityList.addMapping, under the vanilla entity name. A 1.8
// spawn egg is one item whose damage value is the entity id, and ItemMonsterPlacer tints the egg
// texture with the base and the spot overlay with the spot colour.
const SPAWN_EGGS = {
    creeper: { entityId: 50, base: 894731, spot: 0 },
    skeleton: { entityId: 51, base: 12698049, spot: 4802889 },
    spider: { entityId: 52, base: 3419431, spot: 11013646 },
    zombie: { entityId: 54, base: 44975, spot: 7969893 },
    slime: { entityId: 55, base: 5349438, spot: 8306542 },
    ghast: { entityId: 56, base: 16382457, spot: 12369084 },
    pigZombie: { entityId: 57, base: 15373203, spot: 5009705 },
    enderman: { entityId: 58, base: 1447446, spot: 0 },
    caveSpider: { entityId: 59, base: 803406, spot: 11013646 },
    silverfish: { entityId: 60, base: 7237230, spot: 3158064 },
    blaze: { entityId: 61, base: 16167425, spot: 16775294 },
    magmaCube: { entityId: 62, base: 3407872, spot: 16579584 },
    bat: { entityId: 65, base: 4996656, spot: 986895 },
    witch: { entityId: 66, base: 3407872, spot: 5349438 },
    endermite: { entityId: 67, base: 1447446, spot: 7237230 },
    guardian: { entityId: 68, base: 5931634, spot: 15826224 },
    pig: { entityId: 90, base: 15771042, spot: 14377823 },
    sheep: { entityId: 91, base: 15198183, spot: 16758197 },
    cow: { entityId: 92, base: 4470310, spot: 10592673 },
    chicken: { entityId: 93, base: 10592673, spot: 16711680 },
    squid: { entityId: 94, base: 2243405, spot: 7375001 },
    wolf: { entityId: 95, base: 14144467, spot: 13545366 },
    mooshroom: { entityId: 96, base: 10489616, spot: 12040119 },
    ocelot: { entityId: 98, base: 15720061, spot: 5653556 },
    horse: { entityId: 100, base: 12623485, spot: 15656192 },
    rabbit: { entityId: 101, base: 10051392, spot: 7555121 },
    villager: { entityId: 120, base: 5651507, spot: 12422002 },
};

const BY_ENTITY_ID = new Map(Object.values(SPAWN_EGGS).map((egg) => [egg.entityId, egg]));

export const SPAWN_EGG_ITEM_ID = 383;

function hex(rgb: number): string {
    return `#${rgb.toString(16).padStart(6, "0")}`;
}

// ItemMonsterPlacer answers 16777215 for an id no egg is registered under, so an unknown metadata
// tints both layers white instead of borrowing another entity's colours.
export function spawnEggColors(metadata: number): { base: string; spot: string } {
    const egg = BY_ENTITY_ID.get(metadata);
    if (!egg) return { base: "#ffffff", spot: "#ffffff" };
    return { base: hex(egg.base), spot: hex(egg.spot) };
}
